import * as React  from "react";
import { useState, useEffect } from "react";
import FormTip from '../commons/form_tip';
import axios from 'axios';

const Agreement = (props) => {
  const [confirmed, setConfirmed] = useState<boolean>(props.agreement_require);
  const [disableButton, setDisableButton] = useState<boolean>(true);
  const [recordingConsent, setRecordingConsent] = useState<number>(props.recording_consent);

  // 初回ロード
  useEffect(() =>{
    // オンライン資格確認が必須かどうか？
    if(!confirmed){
      setDisableButton(false);
    }else{
      setDisableButton(true);
    }
  },[confirmed])

  // オンライン資格同意登録画面へ遷移
  function jumpOnshikakuaAgreementPage(){
    location.href = (props.onshikaku_url);
  }

  // オンライン資格同意キャンセル画面へ遷移
  function jumpOnshikakuCancelPage(){
    location.href = (props.onshikaku_cancel_url);
  }

  return(
    <>
    <div className="col-md-2 col-lg-3"/>
    <br/>
    <div className="center-block">
      <div className="col-md-2 col-lg-3"/>
      <div className="col-xs-12 col-sm-12 col-md-8 col-lg-6">
        { !props.delf &&
          <>
            <>
              <h4>
                {props.is_clinic ? "オンライン診療を始める前に" : "オンライン服薬指導を始める前に"}
              </h4>
              <br/>
              <pre className="pre-scrollable pre-confirmations pre-wrap">
                ビデオ通話を行うためにはカメラおよびマイクの使用許可を行う必要があります。<br/>
                お手元の端末設定またはビデオ通話開始後に表示される確認メッセージから、カメラおよびマイクの「許可」をお願い致します。<br/>
                <br/>
                サポートブラウザ<br/>
                PC: Chrome/Firefox/Safari/Edge<br/>
                iOS/iPadOS: Safari/Chrome/Firefox/Edge<br/>
                Android: Chrome/Firefox/Edge<br/>
                ※上記サポートブラウザ全てについて「安定版の最新 2 メジャーバージョン」とします。
              </pre>
              <br/>
            </>
            { props.can_record &&
              <>
                <h4>ビデオ通話録音・AI機能利用に関する同意について</h4>
                <br/>
                {
                  props.is_clinic ? (
                    <pre className="pre-scrollable pre-confirmations pre-wrap">
                      当院では、患者様ご自身の振り返りに役立てるとともに、サービス品質の向上を図ることを目的として、診療やご相談内容を記録しております。その一環として、オンラインビデオ通話の音声を録音し、生成AIサービスにより文字起こし・要約を行い、その要約結果をLINEにて患者様へお送りする場合があります。<br/>
                      録音データは、上記目的のみに使用し、当院が適切に管理したうえで1か月間保存後、削除いたします。<br/>
                      録音および AI 処理への同意は任意です。ご同意いただけない場合でも、録音を行わず、通常どおりオンラインビデオ通話による診療をご利用いただけます。<br/>
                    </pre>
                  ):(
                    <pre className="pre-scrollable pre-confirmations pre-wrap">
                      当薬局では、患者様ご自身の振り返りに役立てるとともに、サービス品質の向上を図ることを目的として、服薬指導やご相談内容を記録しております。その一環として、オンラインビデオ通話の音声を録音し、生成AIサービスにより文字起こし・要約を行い、薬歴の記録に活用するとともに、その要約結果をLINEにて患者様へお送りする場合があります。<br/>
                      録音データは、上記目的のみに使用し、当薬局が適切に管理したうえで1か月間保存後、削除いたします。<br/>
                      録音および AI 処理への同意は任意です。ご同意いただけない場合でも、録音を行わず、通常どおりオンラインビデオ通話による服薬指導をご利用いただけます。<br/>
                    </pre>
                  )
                }

                <div className="row">
                  <div className="col-md-4">
                    <input type="radio"
                          className="radio-input"
                          name="recording_consent"
                          value="on"
                          checked={recordingConsent === 1}
                          onChange={() => setRecordingConsent(1)}
                          id="recording_consent_on"/>
                    <label className="m10" htmlFor="recording_consent_on">同意する</label>
                  </div>
                  <div className="col-md-8">
                    <input type="radio"
                          className="radio-input"
                          name="recording_consent"
                          value="off"
                          checked={recordingConsent === 0}
                          onChange={() => setRecordingConsent(0)}
                          id="recording_consent_off"/>
                    <label className="m10" htmlFor="recording_consent_off">同意しない(録音機能は使えなくなります)</label>
                  </div>
                </div>
                <br/>
              </>
            }
        <form className="agreement_confirm justify-content-center"
              id="agreement_confirm"
              action="/rooms/agreement_confirm"
              acceptCharset="UTF-8"
              method="post">
          {
            props.agreement_require &&
            <>
              { props.confirmation.privacy_policy_display_flg === 1 && props.confirmation.privacy_policy &&
                <>
                  <h4>プライバシーポリシー</h4>
                  <br/>
                  <pre className="pre-scrollable pre-confirmations">
                    {props.confirmation.privacy_policy}
                  </pre>
                  <br/>
                </>
              }
              { props.confirmation.agreement_display_flg === 1 && props.confirmation.agreement &&
                <>
                  <h4>
                    {props.is_clinic ? "オンライン診療に関する同意内容" : "オンライン服薬指導に関する同意内容" }
                  </h4>
                  <br/>
                  <pre className="pre-scrollable pre-confirmations">
                    {props.confirmation.agreement}
                  </pre>
                  <br/>
                </>
              }
              { props.reserve_note_display_flg === 1 && props.reserve_note &&
                <>
                  <h4>注意事項・ご用意頂くもの</h4>
                  <br/>
                  <pre className="pre-scrollable pre-confirmations">
                    {props.reserve_note}
                  </pre>
                  <br/>
                </>
              }
              <div className="checkbox text-center">
                <label>
                  <input type="checkbox"
                        name="patient_id"
                        value={props.patient_id}
                        onClick={() => setConfirmed(!confirmed)}>
                  </input>
                  上記内容を確認しました
                </label>
              </div>
            </>
          }
          <div className="text-center">
            <input type="submit"
                    name=""
                    value="ビデオ通話を開始"
                    disabled={disableButton}
                    className={disableButton ? "btn-lg btn message-template-edit-btn disable-btn":"btn-lg btn btn-primary message-template-edit-btn"}
                    id=""
                    data-disable-with="ビデオ通話を開始"/>
          </div>
          <br/>
          <input type="hidden" name="institution_id" value={props.m_institution_id}></input>
          <input type="hidden" name="agreement_require" value={props.agreement_require}></input>
          <input type="hidden" name="recording_consent" value={recordingConsent}></input>
          <input type="hidden" name="room_id" value={props.room_id}></input>
        </form>
          </>
        }
        { (props.is_onshikaku && props.mi_code != null && props.mi_code != "") &&
          <div id="onshikaku_area" className="panel panel-success">
            <div className="panel-heading bold">
              <FormTip description="マイナンバーカードを用いた本人確認を行うことにより、医療機関や薬局において特定健診等の情報や診療/薬剤情報を閲覧できるようになります。">
                <label>オンライン資格確認</label>
              </FormTip>  
            </div>
            <div className="panel-body">
              <div className="row">
                {props.is_clinic ?
                (
                  <>
                    <div className="col-md-12 mb5">オンライン診療を受けるにあたり、マイナンバーカードによるオンライン資格確認登録が推奨されています（未登録でもオンライン診療は可能です）。</div>
                    <div className="col-md-12 mb5">オンライン資格確認webへ遷移後は、画面を閉じずに「オンライン診断等アプリに戻る」ボタンでオンライン診療へお戻りください。</div>
                  </>
                ):(
                  <>
                    <div className="col-md-12 mb5">オンライン服薬指導を受けるにあたり、マイナンバーカードによるオンライン資格確認登録が推奨されています（未登録でもオンライン服薬指導は可能です）。</div>
                    <div className="col-md-12 mb5">オンライン資格確認webへ遷移後は、画面を閉じずに「オンライン診断等アプリに戻る」ボタンでオンライン服薬指導へお戻りください。</div>
                  </>
                )}
                <div className="col-md-12">
                  <div className="col-md-2 col-sm-1 mb5" />
                  <button className="btn btn-lg btn-primary col-md-8 col-sm-10 mb5" onClick={() => jumpOnshikakuaAgreementPage()}>オンライン資格同意登録ページへ</button>
                  <div className="col-md-2 col-sm-1 mb5" />
                </div>
                <div className="col-md-12">
                  <div className="col-md-2 col-sm-1 mb5" />
                  <div className="col-md-8 col-sm-10 mb5 under"><a onClick={() => jumpOnshikakuCancelPage()}>オンライン資格同意取り消し（参照）ページへ</a></div>
                  <div className="col-md-2 col-sm-1 mb5" />
                </div>
              </div>
            </div> 
        </div>
        }
      </div>
    </div>
  </>
  )
}

export default Agreement
